import * as _ from 'lodash';
import { Component } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, CenterActionCreators, IApplicationState, IManualInvoiceLineItemLookupResponse, IManualInvoiceLineItemTaxResponse } from '@nkr/store/index';
import { IBaseResponse, IListItem, IManualInvoiceLineItemTax } from '@nkr/models/index';
import { IErrorItem } from '../../error-item';
import CenterProfileNav from '../edit-nav';
import { profileNavKey } from '../../profile-nav-key';
import { toast } from 'react-toastify';
import ManualTaxLineItemAddFormRow from './line-item-add';
import TaxRow from './tax-row';
import styled from 'styled-components';
import { Table } from 'react-bootstrap';
import ConfirmDelete from './confirm-delete';

const TableWrapper = styled(Table)`
    width: initial;

    & > thead > tr {
        background-color: #ddd;
    }

    & > tbody > tr > td {
        vertical-align: middle;
    }
`;

interface IProps {
    centerId: number,
    isAdmin: boolean,
    isAdminUser: boolean,
    hasDataChanges: boolean,
    onTabClick: (href: string) => void,
    onDataChanged: (hasDataChanged: boolean) => void,
    onUpdateErrors: (list: IErrorItem[]) => void
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<IManualInvoiceLineItemLookupResponse>,
    getLineItems: (centerId: number) => Promise<IManualInvoiceLineItemTaxResponse>,
    removeLineItem: (id: number) => Promise<IBaseResponse>,
    addLineItem: (lineItemType: number, centerId: number, taxPercent: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    lineItems: IManualInvoiceLineItemTax[],
    lineItemTypeList: IListItem[],
    confirmDete: {
        show: boolean,
        data: IManualInvoiceLineItemTax
    }
}

class CenterTaxesTab extends Component<TProps, IState> {
    readonly state: IState = {
        lineItems: [],
        lineItemTypeList: [],
        confirmDete: {
            show: false,
            data: null
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting tax line-items, one moment please...').then(() => {
            Promise.all([
                this.props.getLineItems(this.props.centerId),
                this.props.getLookupData()
            ])
                .then(([lineItemsResponse, lookupDataResponse]) => {
                    if (lineItemsResponse.data.success && lookupDataResponse.data.success) {
                        this.setState({
                            lineItems: lineItemsResponse.data.results,
                            lineItemTypeList: lookupDataResponse.data.results.lineItemTypeList
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading()
                });
        });
    }

    refreshData = () => {
        this.props.showLoading('Getting tax line items, one moment please...').then(() => {
            this.props.getLineItems(this.props.centerId)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            lineItems: response.data.results,
                            confirmDete: {
                                show: false,
                                data: null
                            }
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleAddLineItem = (item: IManualInvoiceLineItemTax) => {
        let { lineItemType, taxPercent } = item;

        this.props.showLoading('Adding line item...').then(() => {
            this.props.addLineItem(lineItemType, this.props.centerId, taxPercent)
                .then(response => {
                    if (response.data.success) {
                        this.refreshData();
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                    toast.success('Tax line item added successfully');
                });
        });
    }

    handleConfirmRemoveLineItem = (id: number) => {
        let data = this.state.lineItems.find(x => x.id == id);

        this.setState({
            confirmDete: {
                show: true,
                data
            }
        });
    }

    handleRemoveLineItem = () => {
        this.props.showLoading('Removing Line Items...').then(() => {
            this.props.removeLineItem(this.state.confirmDete.data.id)
                .then(response => {
                    if (response.data.success) {
                        this.refreshData();
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                    toast.success('Tax line item deleted successfully');
                });
        });
    }

    handleCancelRemoveLineItem = () => {
        this.setState({
            confirmDete: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        return (
            <>
                <CenterProfileNav
                    activeKey={profileNavKey.TAX}
                    isAdmin={this.props.isAdmin}
                    isAdminUser={this.props.isAdminUser}
                    centerId={this.props.centerId}
                    hasChanges={this.props.hasDataChanges}
                    onTabClick={this.props.onTabClick}
                    onSave={null}
                />

                <div style={{ padding: '20px 10px 10px 10px', borderWidth: '1px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', borderRadius: 4, minHeight: 500 }}>
                    <TableWrapper bordered striped condensed>
                        <colgroup>
                            <col style={{ width: '60%' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '20%' }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Taxable Line Item</th>
                                <th style={{ textAlign: 'center' }}>Tax Rate</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.lineItems.map((item, index) =>
                                <TaxRow
                                    key={'tax-row-' + index}
                                    data={item}
                                    onDelete={this.handleConfirmRemoveLineItem} />
                            )}
                        </tbody>
                        {this.state.lineItemTypeList.length > 0 &&
                            <ManualTaxLineItemAddFormRow
                                centerId={this.props.centerId}
                                lineItems={this.state.lineItems}
                                lineItemTypeList={this.state.lineItemTypeList}
                                onAddLineItem={this.handleAddLineItem} />
                        }
                    </TableWrapper>
                </div>

                <ConfirmDelete
                    show={this.state.confirmDete.show}
                    data={this.state.confirmDete.data}
                    onYes={this.handleRemoveLineItem}
                    onNo={this.handleCancelRemoveLineItem} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {}
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch(CenterActionCreators.getLineItemLookupData());
        },
        getLineItems: (centerId: number) => {
            return dispatch(CenterActionCreators.getLineItems(centerId));
        },
        addLineItem: (lineItemType, centerId, taxPercent) => {
            return dispatch(CenterActionCreators.addLineItem(lineItemType, centerId, taxPercent));
        },
        removeLineItem: (id: number) => {
            return dispatch(CenterActionCreators.removeLineItem(id))
        }
    }
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterTaxesTab);